module.exports = __webpack_public_path__ + "img/notepad-01.25139f56.png";